import { Button, Radio, Spin, message } from "antd";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchUserDetails } from "redux/roles/userRoleSlice";
import { downloadEvent, redirectToUrl } from "utilities/generalUtility";
import { Scrollbar } from "react-scrollbars-custom";

export default function PersonalityTabs({ options, loading, userType }) {
  const [selectedOption, setSelectedOption] = useState(userType ?? null);
  const location = useLocation();
  const [btnLoader, setBtnLoader] = useState(false);
  const dispatch = useDispatch();
  const [flag, setflag] = useState(false);

  const queryParams = new URLSearchParams(location.search);

  // Functions

  const onSubmit = async () => {
    try {
      downloadEvent("EditPersonality");
      setBtnLoader(true);
      const body = {
        personalityProfileId: selectedOption,
      };
      const res = await NetworkCall.fetch(
        Request.updatePersonalityType(body),
        false
      );
      selectedOption === null && setflag(true);
      userType && message.success(res?.message);
      userType && dispatch(fetchUserDetails());
      !userType && redirectToDashboard();
      setBtnLoader(false);
    } catch (error) {
      setBtnLoader(false);
    }
  };

  const redirectToDashboard = () => {
    redirectToUrl(
      "/sub-info",
      queryParams.get("diaryId"),
      queryParams.get("diaryTopicId")
    );
  };

  const handleSelect = (option) => {
    setSelectedOption(selectedOption === option.id ? null : option?.id);
    setflag(false);
  };
  return (
    <>
      {loading ? (
        <Spin loading={loading}></Spin>
      ) : (
        <>
          <Scrollbar className="per-card-wrap">
            {/* <Radio.Group value={selectedOption}> */}
            {options &&
              options.map((option) => (
                <div
                  key={option.id}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "20px",
                    padding: "10px",
                    cursor: "pointer",
                    margin: "10px 0",
                    backgroundColor:
                      selectedOption === option.id ? "#e6f7ff" : "white",
                  }}
                  onClick={() => handleSelect(option)}
                >
                  <div style={{ padding: "10px" }}>
                    <h3 style={{ fontWeight: "bold" }}>
                      {option.personalityProfile}
                    </h3>
                    <p>{option.personalityProfileDetail}</p>
                  </div>
                </div>
              ))}
          </Scrollbar>
          {/* </Radio.Group> */}
          <div className="d-flex justify-content-end">
            {!userType && (
              <Button
                type="ghost"
                style={{ marginRight: 10 }}
                onClick={redirectToDashboard}
              >
                I don’t know
              </Button>
            )}

            <Button
              type="primary"
              disabled={
                (!userType && !selectedOption) ||
                userType === selectedOption ||
                flag
              }
              onClick={onSubmit}
              loading={btnLoader}
            >
              {userType ? "Update" : "Submit"}
            </Button>
          </div>
        </>
      )}
    </>
  );
}
